import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";
import {
  GET_EAADHAAR_LOADING,
  GET_EAADHAAR_SUCCESS,
  GET_EAADHAAR_FAILED,
  GET_EAADHAAR_CAPTCHA_LOADING,
  GET_EAADHAAR_CAPTCHA_SUCCESS,
  GET_EAADHAAR_CAPTCHA_FAILED,
  GET_AADHAAR_LINKED_OTP_LOADING,
  GET_AADHAAR_LINKED_OTP_SUCCESS,
  GET_AADHAAR_LINKED_OTP_FAILED,
  VERIFY_AADHAAR_LINKED_OTP_LOADING,
  VERIFY_AADHAAR_LINKED_OTP_SUCCESS,
  VERIFY_AADHAAR_LINKED_OTP_FAILED,
  SAVE_EAADHAAR_LOADING,
  SAVE_EAADHAAR_SUCCESS,
  SAVE_EAADHAAR_FAILED,
} from "../Constants/eAadhaarConstants";

import { handleApiError } from "../Helper/actionHelper";

export const getEAadhaar = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: GET_EAADHAAR_LOADING });
    const requestData = {
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/getEAadhaar",
      requestData,
      {
        headers: headers,
      }
    );
    dispatch({
      type: GET_EAADHAAR_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    dispatch({
      type: GET_EAADHAAR_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const getEAadhaarCaptchaCode = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: GET_EAADHAAR_CAPTCHA_LOADING });
    const requestData = {
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/getAadharCaptchaCodeApi",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: GET_EAADHAAR_CAPTCHA_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    dispatch({
      type: GET_EAADHAAR_CAPTCHA_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const getAadhaarLinkedOTP = (aadhaarRecord, callBack = () => {}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: GET_AADHAAR_LINKED_OTP_LOADING });
    const requestData = {
      token: userLocalData.id,
      aadhar_no: aadhaarRecord.aadhaarNumber,
      valueCaptcha: aadhaarRecord.captchaCode,
      tsTransID: aadhaarRecord.tsTransID,
      secretToken: aadhaarRecord.secretToken,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/sendMobileOtpAadharDetails",
      requestData,
      {
        headers: headers,
      }
    );

    callBack(data);
    dispatch({
      type: GET_AADHAAR_LINKED_OTP_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    dispatch({
      type: GET_AADHAAR_LINKED_OTP_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const verifyAadhaarLinkedOTP = (otpDetails) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: VERIFY_AADHAAR_LINKED_OTP_LOADING });
    const requestData = {
      token: userLocalData.id,
      otp: otpDetails.otp,
      tsTransID: otpDetails.tsTransID,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/verifyMobileOtpAadharDetails",
      requestData,
      {
        headers: headers,
      }
    );
//Your Aadhaar card is verified
    dispatch({
      type: VERIFY_AADHAAR_LINKED_OTP_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    dispatch({
      type: VERIFY_AADHAAR_LINKED_OTP_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const saveEAadhaar = (caseCheckID, checkData) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: SAVE_EAADHAAR_LOADING });
    const requestData = {
      token: userLocalData.id,
      case_check_id: caseCheckID,
      check_data: checkData,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/saveEAadharcheckDetail",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: SAVE_EAADHAAR_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    dispatch({
      type: SAVE_EAADHAAR_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const deleteSavedEAadhaarDetails = () => async (dispatch) => {
  dispatch({
    type: SAVE_EAADHAAR_SUCCESS,
    payload: {},
  });
};

export const deleteGetAadhaarLinkedOTP = () => async (dispatch) => {
  dispatch({
    type: GET_AADHAAR_LINKED_OTP_SUCCESS,
    payload: {},
  });
};

export const deleteVerifyAadhaarLinkedOTP = () => async (dispatch) => {
  dispatch({
    type: VERIFY_AADHAAR_LINKED_OTP_SUCCESS,
    payload: {},
  });
};

export const saveEAadhaarDigi = (payload = {}, callBack=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: SAVE_EAADHAAR_LOADING });
    const requestData = {
      token: userLocalData.id,
      ...payload
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/saveEAadharcheckDetail",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: SAVE_EAADHAAR_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    dispatch({
      type: SAVE_EAADHAAR_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};
